"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBitsPerSToBytesPerMs = exports.convertBytesPerMsToBitsPerS = exports.calculateBitsPerSForSegment = void 0;
var calculateBitsPerSForSegment = function (timeToDownloadMs, numBytes) {
    return numBytes && timeToDownloadMs && (0, exports.convertBytesPerMsToBitsPerS)(numBytes / timeToDownloadMs);
};
exports.calculateBitsPerSForSegment = calculateBitsPerSForSegment;
var convertBytesPerMsToBitsPerS = function (bytesPerMs) {
    return 8000 * bytesPerMs;
};
exports.convertBytesPerMsToBitsPerS = convertBytesPerMsToBitsPerS;
var convertBitsPerSToBytesPerMs = function (bitsPerS) {
    return bitsPerS / 8000;
};
exports.convertBitsPerSToBytesPerMs = convertBitsPerSToBytesPerMs;
